import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { brandPrimary, heartRed } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const { breakpoints } = THEME;

export const styleSheet = StyleSheet.create({
	appBarHeader: {
		display: `flex`,
		gap: 8,
		alignItems: 'center',
	},
	welcomeMessage: {
		color: brandPrimary,
	},
	heartIcon: {
		fill: heartRed,
	},
	column: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		...CssSelectors.allChildren(
			{
				marginTop: '1rem',
			},
			':not(:first-child)'
		),
	},
	integrationOwnershipModal: {
		maxWidth: 400,
	},
	leftColumn: {
		flex: 1,
		minHeight: 200,
		maxWidth: breakpoints.xl,
		paddingBottom: '1.25rem',
	},
	rightColumn: {
		flex: '0 1 0%',
		marginLeft: '1rem',
		minHeight: 200,
	},
	root: {
		boxSizing: 'border-box',
		display: 'flex',
		height: 'fit-content',
		justifyContent: 'center',
		paddingBottom: '2rem',
		padding: 16,
		flex: 1,
	},
});
